// extracted by mini-css-extract-plugin
export default {"speechBubble":"SpeechIndicator_speechBubble__RrxCA"};